// extracted by mini-css-extract-plugin
export default {"container":"SubscriptionManagement_container__HwKN6","title":"SubscriptionManagement_title__m3Tjt"};